import React from 'react';

export default class BaseInputFilter extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            column: this.props.column,
            value: this.props.value,
            initOperation: null,
            operations: []
        };

        this.onOperationChanged = null;

        this.updateLastValue();
    }

    componentWillReceiveProps(newProps) {
        this.state.column = newProps.column;
        this.state.value = newProps.value;
        this.updateLastValue();
        this.setState(this.state);
    }

    updateLastValue() {
        this.lastValue = this.state.value ? this.state.value.value : null;
        this.lastOperation = this.state.value ? this.state.value.operation : null;
    }

    setOperation(key) {
        this.ensureFilterValue();
        this.state.value.operation = key;
        this.applyFilterChanges();
        if (this.onOperationChanged) {
            this.onOperationChanged();
        }
    }

    applyFilterChanges() {
        this.setState(this.state, () => {
            if (this.state.value) {
                if (this.state.value.value === null || this.state.value.value === undefined || this.state.value.value.length < 1) {
                    // игнорируем пустые значения фильтра
                    return;
                }
                if (this.lastValue === this.state.value.value && this.lastOperation === this.state.value.operation) {
                    // если ничего не поменялось, сохранять не нужно
                    return;
                }
            } else if (!this.lastValue && !this.lastOperation) {
                // фильтра как не было, так и нет, игнорируем
                return;
            }
            this.updateLastValue();
            this.props.onChange(this.state.column.fieldName, this.state.value);
        });
    }

    clearFilter() {
        this.state.value = null;
        this.applyFilterChanges();
    }

    renderOperationsList() {
        let curValueClass = "grid-filter-op grid-filter-op-" + (this.state.value ? this.state.value.operation : "default");
        let operations = this.state.operations.map((op, ind, arr) => {
            let operationClass = "grid-filter-op grid-filter-op-" + op.key;
            let operationKey = "operation-" + this.state.column.fieldName + "-" + op.key;
            return (
                <li key={operationKey}>
                    <a onClick={() => this.setOperation(op.key)}
                        disabled={this.props.disabled}
                    >
                        <span className={operationClass}></span> {op.name}
                    </a>
                </li>
            );
        });

        return (
            <div className="input-group-btn">
                <button type="button"
                    className="btn btn-flat dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    disabled={this.props.disabled}
                >
                    <span className={curValueClass}></span>
                </button>
                <ul className="dropdown-menu">
                    {operations}
                    <li className="divider"></li>
                    <li>
                        <a onClick={() => this.clearFilter()}
                            disabled={this.props.disabled}
                        >
                            Сбросить фильтр
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/grid/filter/baseInputFilter.jsx